// extracted by mini-css-extract-plugin
export default {"body":"ActiveSpotlightHero_body__lnqvP"};